import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Utils/NewIcon/index';
import { UserInfo } from 'components/Tasks/TaskBadge/view';
import ProgressMessage from 'components/Utils/ProgressMessage/index';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { useAppSelector } from 'careand-redux/store';
import { api } from 'careand-redux/api/ApiThunks';
import CheckIcon, { FloatTopCPPIcon } from 'components/Tasks/Utils/CheckIcon';
import TaskUtils from 'services/TaskUtils';

const CPPTimelineTask = ({ task, onOpenTask }) => {
  const dispatch = useAppDispatch();
  const physicians = useAppSelector((state) => state.physicians.byId);
  const admins = useAppSelector((state) => state.admins.byId);

  const [loading, setLoading] = useState(false);

  let assignedUser = physicians[task.assigned_user_id] || admins[task.assigned_user_id];
  let createdBy = physicians[task.author_id] || admins[task.author_id];

  async function toggleTaskStatus(event) {
    event.stopPropagation();
    await updateTask({ ...task, status: !task.status, pinned: false });
  }

  async function onPin(event) {
    event.stopPropagation();
    await updateTask({ ...task, pinned: !task.pinned });
  }

  async function updateTask(task) {
    setLoading(true);
    await dispatch(
      api.Tasks.updateTask({
        id: task.id,
        task,
      }),
      { errorTitle: 'Task' },
    );
    setLoading(false);
  }

  const isDue = TaskUtils.isDue(task);

  return (
    <div data-tip data-for={task.id}>
      <div className="item-wrapper clickable" onClick={() => onOpenTask(task)}>
        <div className="top-bar">
          <Icon src="circle-check" />
          <span className="small-title">Task</span>
        </div>
        <div className="item-content">
          <ProgressMessage show={loading} />
          {!loading && (
            <div className="icons-wrapper">
              {isDue && (
                <Icon
                  src="circle-exclamation"
                  alt="Task overdue"
                  showTooltip={true}
                  className="red"
                  height="15px"
                  width="15px"
                />
              )}
              <FloatTopCPPIcon onClick={onPin} float={task.pinned} />
              <CheckIcon width="20px" height="20px" onClick={toggleTaskStatus} task={task} />
            </div>
          )}
          <div className="block">{task.title}</div>
          <div className="block">
            <UserInfo user={assignedUser} label="Assigned To:" />
          </div>
          <div className="block">
            <UserInfo user={createdBy} label="Created By:" />
          </div>
        </div>
      </div>
    </div>
  );
};

CPPTimelineTask.propTypes = {
  task: PropTypes.object.isRequired,
};

export default CPPTimelineTask;
